import React from "react";
import { Nav } from "../components/sections/Nav";
import { Hero } from "../components/sections/Hero";
import { Benefits } from "../components/sections/Benefits";
import { UseCases } from "../components/sections/UseCases";
import { Activations } from "../components/sections/Activations";
import { Analytics } from "../components/sections/Analytics";
import { HowWeWork } from "../components/sections/HowWeWork";
import { Testimonials } from "../components/sections/Testimonials";
import { Contact } from "../components/sections/Contact";
import { Footer } from "../components/sections/Footer";

export default function Landing() {
  return (
    <div className="App">
      <Nav />
      <main>
        <Hero />
        <Benefits />
        <HowWeWork />
        <UseCases />
        <Activations />
        <Analytics />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
